import {
	LoadingSpinner as BaseLoadingSpinner,
	loadingSpinnerDefaults,
} from "@bokio/design-system-base/components/Loading/LoadingSpinner";

import { RenderRequestError } from "./RenderRequestError";

import type { LoadingProps } from "./LoadingProps";
import type { LoadingSpinnerProps as BaseProps } from "@bokio/design-system-base/components/Loading/LoadingSpinner";

export { loadingSpinnerDefaults };

export interface LoadingSpinnerProps extends BaseProps, LoadingProps {
	className?: never;
	children?: never;
}

export const LoadingSpinner = ({
	request,
	requests,
	size,
	appearance,
	hideSoftErrors,
	message,
}: LoadingSpinnerProps) => (
	<RenderRequestError request={request} requests={requests} hideSoftErrors={hideSoftErrors}>
		<BaseLoadingSpinner size={size} appearance={appearance} message={message} />
	</RenderRequestError>
);
